(function(){
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cleanSwiperNode(node) {
    if (!node || !node.classList) return;
    var toRemove = [];
    for (var i = 0; i < node.classList.length; i++) {
      var name = node.classList[i];
      if (name && name.indexOf('swiper-') === 0 && name !== 'swiper') toRemove.push(name);
    }
    toRemove.forEach(function(name) { node.classList.remove(name); });
  }

  function initHPSSwiper() {
    if (typeof Swiper === 'undefined') return;
    var containers = document.querySelectorAll('[data-hpsswiper="true"]');
    if (!containers.length) return;

    containers.forEach(function(optsContainer) {
      var node = optsContainer.querySelector('.swiper');
      if (!node) return;
      if (node.hpSwiper) {
        try {
          node.hpSwiper.destroy(true, true);
          node.hpSwiper = null;
          cleanSwiperNode(node);
        } catch(e) {}
      }

      try {
        var optsAttr = optsContainer.getAttribute('data-options');
        var base = { slidesPerView: 1, spaceBetween: 0, speed: prefersReducedMotion ? 0 : 300, breakpoints: {} };
        var extra = {
          loop: false,
          autoplay: false,
          pagination: false,
          navigation: true,
          hide_arrows_mobile: false
        };
        if (optsAttr && optsAttr.trim()) {
          try {
            var parsed = JSON.parse(optsAttr);
            if (parsed && typeof parsed === 'object') {
              extra.loop = parsed.loop === true;
              extra.pagination = parsed.pagination === true;
              extra.navigation = parsed.navigation !== false;
              extra.hide_arrows_mobile = parsed.hide_arrows_mobile === true;
              if (parsed.autoplay) {
                if (typeof parsed.autoplay === 'object' && typeof parsed.autoplay.delay === 'number') {
                  extra.autoplay = { delay: parsed.autoplay.delay };
                } else {
                  extra.autoplay = { delay: 4000 };
                }
              } else {
                extra.autoplay = false;
              }
            }
          } catch(e) {
            console.warn('[HPS] Errore parsing data-options, uso valori di default', e);
          }
        }

        var style = getComputedStyle(optsContainer);
        var gapMobile = parseInt(style.getPropertyValue('--hps-gap-mobile'), 10);
        var gapTablet = parseInt(style.getPropertyValue('--hps-gap-tablet'), 10);
        var gapDesktop = parseInt(style.getPropertyValue('--hps-gap-desktop'), 10);
        if (isNaN(gapMobile) || gapMobile < 0) gapMobile = 16;
        if (isNaN(gapTablet) || gapTablet < 0) gapTablet = 16;
        if (isNaN(gapDesktop) || gapDesktop < 0) gapDesktop = 16;
        var spm = parseFloat(style.getPropertyValue('--hps-slides-mobile')) || 1;
        var spt = parseFloat(style.getPropertyValue('--hps-slides-tablet')) || 2;
        var spd = parseFloat(style.getPropertyValue('--hps-slides-desktop')) || 4;
        if (spm < 0.1) spm = 1;
        if (spt < 0.1) spt = 2;
        if (spd < 0.1) spd = 4;

        var sectionForOffsets = optsContainer.closest('[id^="hps-"]');
        var hasMobileRightPaddingRemoved = sectionForOffsets && sectionForOffsets.getAttribute('data-remove-right-padding-mobile') === 'true';
        var hasDesktopRightPaddingRemoved = sectionForOffsets && sectionForOffsets.getAttribute('data-remove-right-padding-desktop') === 'true';
        var isFullBleed = sectionForOffsets && sectionForOffsets.getAttribute('data-swiper-full-bleed') === 'true';
        var offsetAfterMobile = (!isFullBleed && hasMobileRightPaddingRemoved) ? 20 : 0;
        var offsetAfterDesktop = (!isFullBleed && hasDesktopRightPaddingRemoved) ? 35 : 0;

        base.spaceBetween = gapMobile;
        base.slidesPerView = spm;
        base.slidesOffsetAfter = offsetAfterMobile;
        base.breakpoints = {
          768: { slidesPerView: spt, spaceBetween: gapTablet, slidesOffsetAfter: offsetAfterDesktop },
          992: { slidesPerView: spd, spaceBetween: gapDesktop, slidesOffsetAfter: offsetAfterDesktop }
        };
        if (prefersReducedMotion && extra.autoplay) extra.autoplay = false;

        var paginationEl = optsContainer.querySelector('.swiper-pagination');
        if (extra.pagination && paginationEl) {
          base.pagination = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active'
          };
        }
        var section = optsContainer.closest('[id^="hps-"]');
        if (section && optsAttr && optsAttr.trim()) {
          try {
            var parsedOpts = JSON.parse(optsAttr);
            if (parsedOpts && typeof parsedOpts === 'object' && parsedOpts.hasOwnProperty('hide_arrows_mobile')) {
              if (parsedOpts.hide_arrows_mobile === true) {
                section.setAttribute('data-hide-arrows-mobile', 'true');
                section.classList.add('hps-hide-arrows-mobile');
              } else {
                section.removeAttribute('data-hide-arrows-mobile');
                section.classList.remove('hps-hide-arrows-mobile');
              }
            }
          } catch (e) {}
        }
        var hideArrowsMobile = section && section.getAttribute('data-hide-arrows-mobile') === 'true';
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var useNavigation = extra.navigation && (!hideArrowsMobile || !isMobile);
        if (useNavigation) {
          var prevEl = optsContainer.querySelector('.swiper-button-prev') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-prev'));
          var nextEl = optsContainer.querySelector('.swiper-button-next') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-next'));
          if (prevEl && nextEl) {
            base.navigation = { prevEl: prevEl, nextEl: nextEl, disabledClass: 'swiper-button-disabled' };
          }
        }

        if (extra.loop) {
          base.loop = true;
          var wrapper = node.querySelector('.swiper-wrapper');
          var slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
          if (slides.length > 0) base.loopedSlides = slides.length;
        }
        if (extra.autoplay && typeof extra.autoplay === 'object' && extra.autoplay.delay) {
          base.autoplay = { delay: extra.autoplay.delay, disableOnInteraction: false, pauseOnMouseEnter: true };
        } else if (extra.autoplay) {
          base.autoplay = { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true };
        }

        var swiper = new Swiper(node, base);
        node.hpSwiper = swiper;

        if (section && section.classList.contains('hps-nav-in-header') && useNavigation) {
          var headerNext = section.querySelector('.section-header-tokens__nav .swiper-button-next');
          var headerPrev = section.querySelector('.section-header-tokens__nav .swiper-button-prev');
          if (headerNext && headerPrev) {
            headerNext.addEventListener('click', function() { swiper.slideNext(); });
            headerPrev.addEventListener('click', function() { swiper.slidePrev(); });
            function syncHeaderDisabled() {
              headerPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
              headerNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
            }
            syncHeaderDisabled();
            swiper.on('slideChangeTransitionEnd', syncHeaderDisabled);
            swiper.on('init', syncHeaderDisabled);
          }
        }

        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
          if (section) {
            document.addEventListener('shopify:section:unload', function unloadHandler(e) {
              var sectionEl = e.target && e.target.nodeType === 1 ? e.target : (e.detail && e.detail.sectionId ? document.getElementById('hps-' + e.detail.sectionId) : null);
              if (sectionEl === section && swiper && swiper.destroy) {
                swiper.destroy(true, true);
                node.hpSwiper = null;
                cleanSwiperNode(node);
                document.removeEventListener('shopify:section:unload', unloadHandler);
              }
            });
          }
        }
      } catch(e) {
        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) console.error('[HPS] Errore init Swiper', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHPSSwiper);
  } else {
    initHPSSwiper();
  }
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHPSSwiper);
  }
})();
